export default __webpack_public_path__ + "static/media/gi.5c0ebf0e.svg";